const STORAGE_KEY = "twin_utm";

const UTM_URL_PARAMS = [
  "utm_source",
  "utm_medium",
  "utm_campaign",
  "utm_content",
  "utm_term",
] as const;

type UtmUrlParam = (typeof UTM_URL_PARAMS)[number];
type UtmEventField = `up_${UtmUrlParam}`;
export type UtmMap = Partial<Record<UtmEventField, string>>;

function read(): UtmMap {
  const raw = localStorage.getItem(STORAGE_KEY);
  if (!raw) return {};
  try {
    const parsed = JSON.parse(raw);
    return parsed && typeof parsed === "object" ? (parsed as UtmMap) : {};
  } catch {
    return {};
  }
}

function captureFromUrl(search: string): void {
  const params = new URLSearchParams(search);
  const captured: UtmMap = {};
  for (const param of UTM_URL_PARAMS) {
    const value = params.get(param);
    if (value) captured[`up_${param}`] = value;
  }
  if (Object.keys(captured).length === 0) return;
  localStorage.setItem(STORAGE_KEY, JSON.stringify(captured));
}

export const utmStorage = {
  read,
  captureFromUrl,
};
